// "Name needs a look" (2.6, founder 2026-10-15, "Build the layers and leave
// existing members alone"; backend utils/nameReview.js and
// controllers/admin.nameReview.js). A new sign-up on 2.6 who kept a name the
// name check doubted is listed for a look. Existing members never carry
// nameReview, so for them nothing here shows at all.
//
// The words the list and the member page use, in one place so the two and
// their tests agree. Every line says what the server does; if the server
// changes, change the words with it.
import { formatEt, firstNameOf } from "./introPauseUtils";

export { formatEt, firstNameOf };

export const NAME_REVIEW_LABEL = "Name needs a look";

/** True while the member's name waits for a look. */
export const isNameFlagged = (user) => !!(user && user.nameReview && user.nameReview.flagged === true);

/** True when the member has ever been listed (flagged now, or answered). */
export const hasNameReview = (user) => !!(user && user.nameReview && (user.nameReview.flagged === true || user.nameReview.outcome));

/** Why they are listed: what they kept, and when. */
export const flaggedLine = (nameReview) => {
  const r = nameReview || {};
  const when = formatEt(r.at);
  const name = r.name ? `"${r.name}"` : "their name";
  return `They kept ${name}${when ? ` on ${when}` : ""} after the name check asked whether it is their real first name.`;
};

/**
 * What an answer also does (backend utils/nameCheck.js markPlausible): the
 * name check stores the first word as a real first name for 30 days,
 * replacing its own "not plausible", so later sign-ups with it are not asked
 * and do not land here.
 */
export const looksFineTeachesLine = (fullName) => {
  const first = firstNameOf(fullName);
  const word = first ? `"${first}"` : "the first word";
  return `Looks fine also tells the name check that ${word} is a real first name, so later sign-ups with it are not asked about it.`;
};
export const RENAME_TEACHES_LINE =
  "The name check also learns that the new first word is a real first name, so later sign-ups with it are not asked about it.";

export const OUTCOME_LABELS = {
  looks_fine: "Looks fine",
  renamed: "Renamed by support",
  member_changed: "Changed by the member",
};

/** How it was answered, once it was. */
export const resolvedLine = (nameReview) => {
  const r = nameReview || {};
  const label = OUTCOME_LABELS[r.outcome];
  if (!label) return "";
  const when = formatEt(r.resolvedAt);
  const to = r.outcome === "renamed" && r.renamedTo ? ` to "${r.renamedTo}"` : "";
  const was = r.name ? ` (they had kept "${r.name}")` : "";
  return `${label}${to}${when ? `, ${when}` : ""}${was}.`;
};

/**
 * What to say when the server refused a change. The server's own message
 * comes first: a name the rules refuse, or an audit row that could not be
 * written (the server writes it before any change, and changes nothing
 * without it; backend controllers/admin.nameReview.js).
 */
export const refusalText = (err) => {
  const status = err && err.response && err.response.status;
  const message = err && err.response && err.response.data && err.response.data.message;
  if (message) return message;
  if (status && status < 500) return `The server refused this (HTTP ${status}). Nothing was changed.`;
  return "The server did not confirm this. Reload the page to see the current name before trying again.";
};
